var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.banner
    ? _c(
        "div",
        {
          class: [
            { "warning-banner": _vm.banner.isWarning },
            "banner mb-2 mt-2"
          ],
          attrs: { role: "alert" }
        },
        [
          _c("i", {
            class: [
              _vm.banner.isWarning ? "fa-exclamation-triangle" : "fa-bullhorn",
              "fas"
            ]
          }),
          _vm._v(" "),
          _vm.localeFi
            ? _c("span", [_vm._v(_vm._s(_vm.banner.bannerTextFi))])
            : _vm._e(),
          _vm._v(" "),
          _vm.localeSv
            ? _c("span", [_vm._v(_vm._s(_vm.banner.bannerTextSv))])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }